/**
 * Vuex
 *
 * @library
 *
 * https://vuex.vuejs.org/en/
 */

// Lib imports
import Vue from 'vue'
import Vuex from 'vuex'
import { firestoreAction, vuexfireMutations } from 'vuexfire'
import { db } from '../main'

// Store functionality
// import actions from './actions'
// import getters from './getters'
// import modules from './modules'
// import mutations from './mutations'
// import state from './state'

Vue.use(Vuex)

// Create a new store
const store = new Vuex.Store({
  state: {
    drawer: false,
    apresentacoes: [],
    indice: {},
    repertorio: []
  },
  actions: {
    toggleDrawer (context) {
      context.drawer = !context.drawer
      console.log(context.drawer)
    },
    bindApresentacoes: firestoreAction(({ bindFirestoreRef }) => {
      return bindFirestoreRef('apresentacoes', db.collection('apresentacoes'))
    }),
    bindIndice: firestoreAction(({ bindFirestoreRef }) => {
      return bindFirestoreRef('indice', db.collection('indice'))
    })
  },
  mutations: {
    toggleDrawer (state) {
      state.drawer = !state.drawer
    },
    setDrawer (state, val) {
      state.drawer = val
    },
    ...vuexfireMutations
  }
})

export default store
